import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';

export interface ChipItem {
  key: string;
  chipkey: string;
  isExcluded?: boolean;
  isSuggested?: boolean;
  isMandatory?: boolean;
  [key: string]: any;
}

@Component({
  selector: 'app-custom-chip',
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule,
    MatChipsModule,
    TitleCasePipe,
  ],
  templateUrl: './custom-chip.component.html',
  styleUrls: ['./custom-chip.component.scss'],
})
export class CustomChipComponent implements OnChanges {
  /** List of chip items to display */
  @Input() chips: ChipItem[] = [];

  /** Whether chips can be removed. Default: true */
  @Input() removable: boolean = true;

  /** Whether to show the exclude (minus) toggle button. Default: true */
  @Input() showExclude: boolean;

  /** Apply titlecase to chip label. Default: true */
  @Input() titleCase: boolean = true;

  /**
   * 'default'    — white pill with minus + X (filter chip)
   * 'suggestion' — clickable chip with leading + icon (add suggestion)
   */
  @Input() variant: 'default' | 'suggestion' = 'default';

  /** Emits the chip that was removed (X clicked) */
  @Output() removed = new EventEmitter<ChipItem>();

  /** Emits the chip whose exclude state was toggled */
  @Output() excluded = new EventEmitter<ChipItem>();

  /** Emits when a suggestion chip is clicked */
  @Output() added = new EventEmitter<ChipItem>();

  /** Emits when a chip's mandatory state is toggled */
  @Input() showMandatory = false;

  /** Emits the chip whose mandatory state was toggled */
  @Output() mandatory = new EventEmitter<ChipItem>();




  onAdd(chip: ChipItem): void {
    this.added.emit(chip);
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  onRemove(chip: ChipItem): void {
    this.removed.emit(chip);
  }

  onExclude(chip: ChipItem): void {
    this.excluded.emit(chip);
  }



  onMandatoryClick(chip: ChipItem) {
    chip.isMandatory = !chip.isMandatory;
    this.mandatory.emit(chip);
  }

  /**
   * Sanitizes the chip label by removing specific suffixes and trimming whitespace.
   * @param value The chip label to sanitize.
   * @returns The sanitized chip label.
   */
  sanitizeChipLabel(value: string | undefined): string {
    return (value || '').replace(/\.(aisearch|searchastext|includedaisearch)$/i, '').trim();
  };

}
